module.exports = __webpack_public_path__ + "src/assets/img/phone-title.baac9303.png";